import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';

const success = (resolve, response) => {
  resolve(purchaseTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(purchaseTransformer.fetch(errors));
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/purchases/mark-as-cancel/${id}`)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/markAsCancel.js